
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import SignupWizard from 'components/SellerSignup/SignupWizard';
import BillingInfo from 'components/SellerSignup/Tabs/BillingInfo';
import ChoosePlan from 'components/SellerSignup/Tabs/ChoosePlan';
import Confirmation from 'components/SellerSignup/Tabs/Confirmation';
import GetStarted from 'components/SellerSignup/Tabs/GetStarted';
import { addValidationRule } from 'formsy-react';
import React, { Component } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import { addSeller } from 'services/Seller';
import { getPaymentIntent } from 'services/stripe';
import { extractFirstLastName } from '../../helpers/parseName';
import { isNotBlankString, isValidCellNumber, isValidEmail } from '../../helpers/validation';
import { getToken } from '../../services/fetch';
import Config from 'Config'
import './SellerSignupContainer.less'
import { createPassword } from '../../helpers/general';
import { getPlan } from '../../services/subscription';
import { getAllCategories } from '../../services/categories';
import { verifyEmail } from '../../services/User';
import { pick } from 'lodash';
import utilityMethods from '../../utils/utilityMethods';


import { logInitiateCheckout, logInitiatePlanSelection, logInitiateSignup, logPurchase } from '../../common/analytics';
import { formatPhone } from '../../helpers/parsePhone';

addValidationRule('isNotBlankString', isNotBlankString);
addValidationRule('isValidCellNumber', isValidCellNumber);
addValidationRule('isValidEmail', isValidEmail);
class SellerSignupContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTabIndex: 0,
            hasDefaultPlan: false,
            stripe: undefined
        }
        if (getToken()) {
            this.props.history.push('')
        }
        loadStripe(Config.stripe.key).then(stripe => this.setState({ stripe }));
    }

    moveToNextTab = (params) => {
        if (this.state.activeTabIndex == 0) {
            logInitiatePlanSelection(pick(this.state, ['selectedCategory',  'phone','contactName', 'email']));
        }
        else if (this.state.activeTabIndex == 1) {
            logInitiateCheckout(params);
        }
        this.setState({ activeTabIndex: this.state.activeTabIndex + 1 })
    }

    componentDidMount() {
        logInitiateSignup();
        const signUpInfo = utilityMethods.getSignupInfo();
        this.setState({ ...signUpInfo })
        if (this.props.match.params.planID) {
            this.setState({ activeTabIndex: 2 })
            this.showLoader();
            getPlan(this.props.match.params.planID).then(({ data }) => {
                if (data) {
                    getAllCategories().then(({ data: categories }) => {
                        this.setState({
                            selectedPlan: { plan: { ...data, planName: data.name, planType: data.type }, features: data.features },
                            selectedCategory: categories.find(c => c.categoryID == data.categoryID),
                            hasDefaultPlan: true,
                            categoryID: data.categoryID
                        }, () => { logInitiateCheckout(pick(this.state, ['selectedPlan', 'selectedCategory'])) })
                        this.hideLoader();
                    })
                } else {
                    this.props.history.push('/signin');
                }
            })

        }
    }

    postForm = async (form) => {
        try {
            if (this.state.hasDefaultPlan) {
                const res = await verifyEmail(this.state.email);
                if (res.resStatus != 200) {
                    this.setState({ cardError: res.message })
                    return;
                }
            }
            const userFullName = extractFirstLastName(this.state.contactName);
            const password = createPassword(5);
            this.showLoader();
           if (this.state.selectedPlan.plan.trialDays && !this.state.selectedPlan.plan.requiresPaymentMethod) {
                const seller = {
                    email: this.state.email,
                    phone: formatPhone(this.state.phone),
                    contactFirstName: userFullName.firstName,
                    contactLastName: userFullName.lastName,
                    planID: this.state.selectedPlan.plan.planID,
                    password,
                    categoryID: this.state.categoryID,
                    promo: this.state.promo
                };
                const sellerRes = await addSeller(seller);
                if (sellerRes.resStatus == 200) {
                    this.setState({ password })
                    this.moveToNextTab();
                } else {
                    this.setState({ activeTabIndex: 0, cardError: '', })
                }
            } else {

                if (!this.state.card) {
                    this.setState({ cardError: 'Invalid card details.' })
                    return;
                }

                // payment method creation
                const paymentMethodRes = await this.state.stripe.createPaymentMethod({
                    type: 'card',
                    card: this.state.card,
                    billing_details: {
                        name: this.state.businessName,
                        email: this.state.email,
                    }
                });

                if (paymentMethodRes.error) {
                    this.setState({ cardError: paymentMethodRes.error.message })
                    return;
                }

                const paymentRes = await getPaymentIntent({ planID: this.state.selectedPlan.plan.planID, email: this.state.email, promo: this.state.promo })
                const paymentConfirmation = await this.state.stripe.confirmCardPayment(paymentRes.data.intent.client_secret, {
                    payment_method: paymentMethodRes.paymentMethod.id,
                    setup_future_usage: 'off_session'
                });

                if (paymentConfirmation.error) {
                    this.setState({ cardError: paymentConfirmation.error.message })
                } else {
                    if (paymentConfirmation.paymentIntent.status === 'succeeded') {
                        //payment done
                        logPurchase(paymentConfirmation.paymentIntent.amount);
                        const seller = {
                            paymentIntentID: paymentRes.data.intent.id,
                            email: this.state.email,
                            phone: formatPhone(this.state.phone),
                            contactFirstName: userFullName.firstName,
                            contactLastName: userFullName.lastName,
                            planID: this.state.selectedPlan.plan.planID,
                            password,
                            categoryID: this.state.categoryID,
                        };

                        const sellerRes = await addSeller(seller);
                        if (sellerRes.resStatus == 200) {
                            this.setState({ password })
                            this.moveToNextTab();
                        } else {
                            this.setState({ activeTabIndex: 0, cardError: '', })
                        }
                    }
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            utilityMethods.resetSignupInfo();
            this.hideLoader();
        }
    }

    showLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        this.setState({
            showLoader: true
        })
    }

    hideLoader = () => {
        document.body.style.overflowY = 'unset'
        this.setState({
            showLoader: false
        })
    }

    moveBack = () => {
        if (this.state.hasDefaultPlan) {
            this.props.history.goBack()
        }
        else {
            this.setState({ activeTabIndex: this.state.activeTabIndex - 1 })
        }
    }

    render() {
        const { activeTabIndex } = this.state;
        return <div className='seller-signup-container'>
            {this.state.showLoader ? <Dimmer active>
                <Loader indeterminate size='massive' />
            </Dimmer> : ''}
            {activeTabIndex != 3 ? <SignupWizard
                activeTabIndex={this.state.activeTabIndex}
                moveBack={this.moveBack}
            /> : ''}
            <div className={`seller-signup-tab${activeTabIndex != 0 ? ' hidden' : ''}`}>
                <GetStarted moveToNextTab={this.moveToNextTab} formState={this.state} onChange={(subState) => this.setState({ ...subState })} />
            </div>
            <div className={`seller-signup-tab${activeTabIndex != 1 ? ' hidden' : ''}`}>
                <ChoosePlan selectedCategory={this.state.selectedCategory} moveToNextTab={this.moveToNextTab} onChange={(plan) => this.setState({ selectedPlan: plan })} plans={this.state.plans} />
            </div>
            <div className={`seller-signup-tab${activeTabIndex != 2 ? ' hidden' : ''}`}>
                {this.state.stripe ? <Elements stripe={this.state.stripe}> <BillingInfo
                    selectedCategory={this.state.selectedCategory}
                    activeTabIndex={activeTabIndex}
                    onSubmit={this.postForm}
                    stripe={this.state.stripe}
                    selectedPlan={this.state.selectedPlan}
                    cardError={this.state.cardError}
                    onChange={(subState) => this.setState({ ...subState })}
                    hasBasicInfoForm={this.state.hasDefaultPlan}
                    phone={this.state.phone}
                    contactName={this.state.contactName}
                    email={this.state.email}
                /> </Elements> : ''}
            </div>
            {activeTabIndex == 3 ? <Confirmation user={this.state.contactName} email={this.state.email} password={this.state.password} /> : ''}

        </div >
    }
}

export default SellerSignupContainer;